import {
  NoneOrderDocumentClassDto,
  NoneOrderTagDetailResponse,
} from "apis/data-contracts";
import { KOREA_REGION } from "config/constant";
import { atom } from "recoil";

export const selectedArchivesDocumentClassState =
  atom<NoneOrderDocumentClassDto>({
    key: "selectedArchivesDocumentClassState",
    default: undefined,
  });

export const selectedArchivesProvinceState = atom<keyof typeof KOREA_REGION>({
  key: "selectedArchivesProvinceState",
  default: undefined,
});

export const selectedArchivesCityState = atom<string | undefined>({
  key: "selectedArchivesCityState",
  default: undefined,
});

export const selectedArchivesBusinessTagsState = atom<
  NoneOrderTagDetailResponse[]
>({
  key: "selectedArchivesBusinessTagsState",
  default: [],
});

export const selectedArchivesTopicTagsState = atom<
  NoneOrderTagDetailResponse[]
>({
  key: "selectedTopicTagsState",
  default: [],
});
